const queryKeys = {
  workspaces: 'workspaces',
  workspace: 'workspace',
  users: 'users',
  campaigns: 'campaigns',
  templates: 'templates',
  segments: 'segments',
  segmentDetails: 'segment-details',
  accountMetrics: 'account-metrics',
  quotaUsage: 'quota-usage',
  teamMembers: 'team-members',
  emailMetrics: 'email-metrics',
  rolePermissions: 'role-permissions',
  activityLogs: 'activity-logs',
  churnMetrics: 'churn-metrics',
  churnSignals: 'churn-signals',
  notifications: 'notifications',
  companyAccount: 'company-account',
  apiCredentials: 'api-credentials',
  domainNames: 'domain-names',
  domainDetails: 'domainDetails',
  inquiry: 'inquiry',
  tickets: 'tickets',
  comments: 'comments',
  ticketActivity: 'ticket-activity',
  paddleCheckoutPlans: 'paddle-checkout-plans',
};

export default queryKeys;
